import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionService } from '../../tipo-revision/tipo-revision.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { VehiculoService } from '../../vehiculo/vehiculo.service';
import { RevisionService } from '../revision.service';
import { TipoAceiteCreateComponent } from '../tipo-aceite-create/tipo-aceite-create.component';
import { TipoAceiteService } from '../tipo-aceite.service';
import { UsuarioCreateComponent } from '../../usuario/usuario-create/usuario-create.component';

@Component({
  selector: 'app-revision-view',
  templateUrl: './revision-view.component.html',
  styleUrls: ['./revision-view.component.scss']
})
export class RevisionViewComponent implements OnInit {

  @Input() element: any;
  active: number = 1;

  form: FormGroup = new FormGroup({});
  tipo_aceites: any[] = [];
  vehiculos: any[] = [];
  tipos: any[] = [];
  usuarios: any[] = [];
  encargados: any[] = [];

  lineas: any[] = [];
  get total() { return this.lineas.map(e => e.precio_unitario * e.cantidad).reduce((t, e) => t + e, 0) }

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: RevisionService,
    public formatter: FormatterService,
    private modalService: NgbModal,
    private tipoAceiteService: TipoAceiteService,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService,
    private tipoService: TipoRevisionService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      tipo_revision_id: ['', [Validators.required]],
      fecha: ['', [Validators.required]],
      kilometraje: ['', [Validators.required]],
      proxima_revision: ['', [Validators.required]],
      fecha_estimada: [''],
      encargado_id: [''],
      detalle: ['', [Validators.required]],
      vehiculo_id: ['', [Validators.required]],
      tipo_pago: ['', [Validators.required]],
      tipo_documento: ['', [Validators.required]],
    });
    this.getTiposServicio();
    this.getVehiculos();
    this.cargarEncargados();
    this.form.patchValue(this.element);
    this.lineas = this.element.lineas;
    if (this.element.fecha) this.form.patchValue({ fecha: this.element.fecha.substring(0, 10) });
    if (this.element.fecha_estimada) this.form.patchValue({ fecha_estimada: this.element.fecha_estimada.substring(0, 10) });
    this.form.disable();
  }

  cargarEncargados(asignarUltimo: boolean = false) {
    this.loading.show()
    this.usuarioService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.encargados = res.filter((e: any) => e.rol_id != 4);
        if (asignarUltimo && this.encargados.length > 0) this.form.patchValue({ encargado_id: this.encargados[this.encargados.length - 1].id });
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  agregarEncargado() {
    const modalRef = this.modalService.open(UsuarioCreateComponent, { size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.cargarEncargados(true);
    }, (reason: any) => { });
  }

  searchFnEncargado(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.apellido].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Vehículo registrado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de vehículo.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  getTiposServicio(): void {
    this.loading.show();
    this.tipoService.index().subscribe({
      next: (res) => {
        this.loading.hide();
        this.tipos = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de tipos.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  getVehiculos(): void {
    this.loading.show();
    this.vehiculoService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.vehiculos = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de vehículos.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  getUsuarios(): void {
    this.loading.show();
    this.usuarioService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.usuarios = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de usuarios.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }

  getTipoAceites(): void {
    this.loading.show();
    this.tipoAceiteService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.tipo_aceites = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de tipos de aceites.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  addTipoAceite(): void {
    const modalRef = this.modalService.open(TipoAceiteCreateComponent, { windowClass: 'clear-modal', size: 'sm', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.getTipoAceites();
    }, (reason: any) => { });
  }
}
